export type ThemeViews =
  // legal footer
  | 'LEG_FOO'
  // visualizzazione preventivo normale
  | 'QUO_PREV_STD'
  // visualizzazione preventivo compatta
  | 'QUO_PREV_CMP'
  // visualizzazione preventivo su impegni
  | 'QUO_OLBIGATION'
  // frase su accettazione preventivo
  | 'QUO_CONF_INF'
  // modale di conferma su conferma preventivo
  | 'QUO_CONF_ALERT'
  // paragrafo di descrizione del documento da caricare
  | 'UPL_DOC_DESC'
  // toast quando viene completato l'upload con successo
  | 'UPL_DOC_SUCC_TOAST'
  // modale di prefazione prima dell'avvio della firma
  | 'SIGN_PREFACE'
  // modale di prefazione prima della modifica del preventivo
  | 'QUO_EDIT_PREFACE'
  // modale di prefazione prima della richiesta documenti
  | 'DOCS_REQ_PREFACE'
  // numerazione per gli step
  | 'WIZARD_STEP_NUMBER'
  // input importo totale modificabile
  | 'QUO_AMOUNT_INPUT_EDITABLE'
  // input importo totale non modificabile
  | 'QUO_AMOUNT_INPUT_READONLY'
  // input durata modificabile
  | 'QUO_DURATION_INPUT_EDITABLE';
